module.exports = __webpack_public_path__ + "img/87.1.4cec93c6.jpg";